import classes from "./ResultSet.module.css"
import { useTranslation } from "react-i18next"

const ResultInit = props => {
    const { t } = useTranslation()
    if (props.possibleResults.length === 0) {
        return <div className={classes.WrapperNoScroll}>{t("misc:SeedListing.NoSeedFoundYet")}</div>
    }
    if (props.possibleResults.length === 1) {
        return (
            <div className={classes.WrapperNoScroll}>
                <div> {t("misc:SeedListing.OneSeedFound")}</div>
                <div style={{ marginTop: 10 }}>
                    <button className={classes.Button} onClick={props.storeRes}>
                        {t("misc:SeedListing.StoreSeed")}
                    </button>
                </div>
            </div>
        )
    }
    return <div className={classes.WrapperNoScroll}>{t("misc:SeedListing.TooManySeeds")}</div>
}

export default ResultInit
